<div class="container_ header">
    <ng-container *ngIf="!shouldShowHeader; else securedLevel">
        <a [routerLink]="logoNavigateLink?.url"
           [class.disabled-link]="!logoNavigateLink"
           routerLinkActive="active-link">
            <img src="/assets/img/deloitte-logo.svg" alt="Deloitte" class="logo-img">
        </a>
    </ng-container>
</div>

<!--SECURED LEVEL HEADER (Deloitte user only)-->
<ng-template #securedLevel>
    <div class="header__left-wrapper">
        <div class="logo-wrapper">
            <a [routerLink]="logoNavigateLink?.url"
               [queryParams]="logoNavigateLink?.queryParams"
               [class.disabled-link]="!logoNavigateLink"
               routerLinkActive="active-link">
                <img src="/assets/img/deloitte-logo.svg" alt="Deloitte" class="logo-img">
            </a>

            <div class="logo-text">DBadge</div>
        </div>

        <nav *ngIf="navigationItems.length > 0" class="header__nav">
            <ul class="nav-menu">
                <ng-container *ngFor="let navigationItem of navigationItems">
                    <ng-container *ngIf="!navigationItem.children">
                        <li class="nav-menu-item" *ngIf="navigationItem.routerLink !='search-employee' && isAvailableForCurrentUserRole(navigationItem)">
                            <a
                                [routerLink]="navigationItem.routerLink"
                                [queryParams]="navigationItem.queryParams"
                                queryParamsHandling="preserve"
                                routerLinkActive="active-link">{{navigationItem.itemName}}
                            </a>
                        </li>
                        <li class="nav-menu-item" *ngIf="isEmployeeSearchAvailableForCurrentUser() && navigationItem.routerLink =='search-employee'">
                            <a
                                [routerLink]="navigationItem.routerLink"
                                queryParamsHandling=""
                                routerLinkActive="active-link">{{navigationItem.itemName}}
                            </a>
                        </li>
                    </ng-container>
                    
                    <!-- UPDATED: Fixed dropdown with proper click-outside functionality -->
                    <ng-container *ngIf="navigationItem.children">
                        <li class="nav-menu-item" *ngIf="isAvailableForCurrentUserRole(navigationItem)">
                            <a
                                [class.active-link]="navigationItem.childrenRouterLinks.includes(window.location.pathname.split('/')[1])"
                                [matMenuTriggerFor]="subActionsMenu"
                                (menuOpened)="navigationItem.isOpened = true"
                                (menuClosed)="navigationItem.isOpened = false"
                                #menuTrigger="matMenuTrigger">{{navigationItem.itemName}}
                            </a>
                            <i *ngIf="isAvailableForCurrentUserRole(navigationItem)"
                                class="icon-arrow-expand"
                                [class.is-open]="navigationItem.isOpened">
                            </i>
                        </li>
                    </ng-container>

                    <!-- FIXED: Added hasBackdrop="true" and removed appClickOutside -->
                    <mat-menu
                        #subActionsMenu
                        xPosition="before"
                        [class]="'bulk-actions-menu'"
                        [hasBackdrop]="true"
                        backdropClass="menu-backdrop">

                        <li class="nav-menu-child" *ngFor="let navigationItemChildren of navigationItem.children">
                            <a *ngIf="isAvailableForCurrentUserRole(navigationItemChildren) && isAvailableForCurrentConfiguration$(navigationItemChildren.itemName) | async"
                               [routerLink]="navigationItemChildren.routerLink"
                               [queryParams]="navigationItemChildren.queryParams"
                               class="nav-menu-item__link"
                               routerLinkActive="nav-menu-childActiveLink"
                               (click)="closeNavigationItem(navigationItem)">{{navigationItemChildren.itemName}}</a>
                        </li>
                    </mat-menu>
                </ng-container>
            </ul>
        </nav>
    </div>

    <div class="header__right-wrapper" *ngIf="shouldShowUserProfile && user">
        <ui-user-profile-dropdown class="user-profile" [user]="user"
                                  [userPhotoFile]="userPhotoFile"></ui-user-profile-dropdown>
    </div>

    <div class="header__right-wrapper" *ngIf="shouldShowHeaderMenu">
        <ui-header-menu class="header-menu"></ui-header-menu>
    </div>
</ng-template>